import React, { useState, useEffect } from 'react';
import { MessageBar, MessageBarType, PrimaryButton, Icon } from '@fluentui/react';
import Api from '../../services/Api'
import { mapDbUserForPeoplePicker } from '../formFields/PeoplePicker';
import { Spinner, SpinnerSize } from '@fluentui/react';
import { groupBy } from '../../helpers/HelperMethods';
import MasterDataManagersItem from './MasterDataManagersItem';

const CountryEmailNotifications = ({depth, getEndpoint, saveEndpoint, onItemNameRender, groupByProperty, keyProperty, onHeaderNameRender}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setSaving] = useState(false);
    const [allMasterData, setAllMasterData] = useState({});
    const [masterData, setMasterData] = useState([]);
    const [receivers, setReceivers] = useState({});
    const [message, setMessage] = useState();
    const [events, setEvents] = useState([]);
    const [showGroup, setShowGroup] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            await getGeographies();
        }

        fetchData();
    }, []);

    const getGeographies = async () => {
        setIsLoading(true);
        try {
            const response = await Api.get(getEndpoint);
            const data = response.data;

            const masterData = depth ? data.filter(x => x.depth === depth) : data;

            const users = data.reduce((notificationReceivers, t) => {
                return {
                    ...notificationReceivers,
                    [t.id]: t.notificationReceivers.map(u => mapDbUserForPeoplePicker(u))
                }
            }, []);

            const evts = data.reduce((notificationEvents, t) => {
                return {
                    ...notificationEvents,
                    [t.id]: t.notificationEvents
                }
            }, []);

            setAllMasterData(data.reduce((accumulator, currentValue) => { return {...accumulator, [currentValue[keyProperty]]: currentValue}}, {}));
            setMasterData(masterData);
            setReceivers(users);
            setEvents(evts);
            
            setIsLoading(false);
        }
        catch(error) {
            setMessage({
                type: MessageBarType.error,
                text: 'Cannot get Country settings from database: ' + error
            });
        }
    }

    const saveSettings = async () => {
        setSaving(true);
        setMessage();
        const combinedKeys = { ...receivers, ...events };

        const postData = {};
        for (const key in combinedKeys) {
            if (receivers.hasOwnProperty(key) && events.hasOwnProperty(key)) {
                postData[key] = {
                geographyId: key,
                receivers: receivers[key],
                events: events[key].map(event => event.siteEvent)
              };
            } else if (receivers.hasOwnProperty(key)) {
                postData[key] = {
                geographyId: key,
                receivers: receivers[key],
                events: []
              };
            } else {
                postData[key] = {
                geographyId: key,
                receivers: [],
                events: events[key].map(event => event.siteEvent)
              };
            }
          }

        try {
            const res = await Api.post(saveEndpoint, postData);
            const post = res.status;

            if(post === 200) {
                setSaving(false);
                setMessage({
                    type: MessageBarType.success,
                    text: 'Settings have been saved.'
                });
            } else {
                setSaving(false);
                setMessage({
                    type: MessageBarType.error,
                    text: 'Cannot save settings: ' + post.message
                });
            }
        } catch(error) {
            setSaving(false);
            console.log(error);
        };
    }

    const onSelectedUsers = (id, newUsers) => {
        const u = {
            ...receivers,
            [id]: newUsers
        }
        setReceivers(u);
    }

    const msg = message && 
                <MessageBar messageBarType={message.type}>
                    {message.text}
                </MessageBar>

    const btn = isSaving
    ? <Spinner className='settings-btn' size={SpinnerSize.large} />
    : <PrimaryButton className='settings-btn' onClick={saveSettings}>Save</PrimaryButton>

    const onCheckedEvents = (id, newEvents) => {
        const c = {
            ...events,
            [id]: newEvents
        }
        setEvents(c);
    }

    const groupedMasterData = groupBy(masterData, groupByProperty);

    const items = Object.keys(groupedMasterData).sort().map((x, index) => 
                    <div key={index} style={containerStyles}>
                        <div style={headerStyles} onClick={() => setShowGroup({...showGroup, [x]: !showGroup[x]})}>
                            <Icon iconName={showGroup[x] ? 'ChevronUp' : 'ChevronDown'} style={iconStyles}/> 
                            {onHeaderNameRender(allMasterData[x])}
                        </div>
                        {
                            showGroup[x] &&
                            <div style={itemsStyles}>
                            {
                                groupedMasterData[x].sort((a, b) => a.key > b.key ? 1 : -1 ).map(t => {
                                    return <MasterDataManagersItem
                                        key={t.id} 
                                        name={onItemNameRender(t)} 
                                        managers={t.notificationReceivers}
                                        onSelectedUsers={(users) => onSelectedUsers(t.id, users)} 
                                        events={t.notificationEvents}
                                        onCheckedEvents={(evs) => onCheckedEvents(t.id, evs)}
                                    />
                                })
                            }
                            </div>
                        }
                    </div>
                )

    return (
        <div>
            {   
                isLoading
                ? <Spinner style={{margin: '200px'}} size={SpinnerSize.large} />
                :  
                <div>
                    {items}
                    {btn}
                    {msg}
                </div>
            }
        </div>
    );
}

const iconStyles = {
    verticalAlign: 'middle',
    marginRight: 10
}

const containerStyles = {
    margin: '0 20px 20px 10px',
}

const headerStyles = {
    fontSize: 18,
    cursor: 'pointer'

}
const itemsStyles = {
    margin: '20px 0 0 29px',
}

export default CountryEmailNotifications;


// WEBPACK FOOTER //
// ./src/components/Settings/CountryEmailNotifications.js